var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["tenancy-all-ecircular"] },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.$t("eCircular.alleCircular"),
            buttons: [_vm.refreshBtn],
            needGoback: true,
            fullScreen: true,
          },
        },
        [
          _c("template", { slot: "back-button" }, [
            _c(
              "span",
              {
                staticClass: "back",
                on: {
                  click: function ($event) {
                    return _vm.navBack()
                  },
                },
              },
              [_vm._v("\n        < " + _vm._s(_vm.$t("back")) + "\n      ")]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "all-list" }, [
        _c("div", { staticClass: "history-content" }, [
          _vm.eCircularSearchCount
            ? _c("div", { staticClass: "total-count" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("total")) +
                      ": " +
                      _vm._s(_vm.eCircularSearchCount)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-results" },
            [
              _c("HKLTable", {
                ref: "table",
                attrs: {
                  dataSource: _vm.orderedItems,
                  columns: _vm.tableColumns,
                  sort: _vm.eCircularTableOrder.orderKey || "sentAt",
                  filterBar: true,
                  onFilter: false,
                },
                on: { filter: _vm.onFilter, loadmore: _vm.loadMore },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "eCircularContentModal",
          attrs: {
            modalType: "large-modal",
            showCloseBtn: false,
            modalId: _vm.eCircularContentModalId,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.showingEcircular.id
                ? _c("ECircularPreviewIndex", {
                    key: _vm.showingEcircular.id,
                    attrs: { eCircular: _vm.showingEcircular },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEmptyAttachments,
                      expression: "!isEmptyAttachments",
                    },
                  ],
                  staticClass: "attachments input-row",
                },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("attachments")))]),
                  _vm._v(" "),
                  _c("EditAttachments", {
                    attrs: {
                      canEdit: false,
                      canDelete: false,
                      sourceId: _vm.sourceId,
                      getFileLengthID: _vm.sourceId,
                      canDownloadAll: true,
                      zipName:
                        _vm.showingEcircular.subject +
                        "_eCircular_Documents.zip",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeECircularContentModal()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }